window.simplemaps_usmap_mapdata={
  main_settings: {
   //General settings
    width: "responsive", //'700' or 'responsive'
    background_color: "#FFFFFF",
    background_transparent: "yes",
    border_color: "#ffffff",
    popups: "no",

    //State defaults
    state_description: "State Description",
    state_color: "#EEEEEE",
    state_hover_color: "#EEEEEE",
    state_url: "",
    border_size: 1.5,
    all_states_inactive: "yes",
    all_states_zoomable: "no",
    location_description: "",
    location_color: "#2041D4",
    location_opacity: 0.8,
    location_hover_opacity: 1,
    location_url: "",
    location_size: 25,
    location_type: "square",
    location_image_source: "frog.png",
    location_border_color: "#FFFFFF",
    location_border: 2,
    location_hover_border: 2.5,
    all_locations_inactive: "no",
    all_locations_hidden: "no",

    //Label defaults
    label_color: "#d5ddec",
    label_hover_color: "#d5ddec",
    label_size: 22,
    label_font: "Arial",
    hide_labels: "no",
    hide_eastern_labels: "no",
    manual_zoom: "no",
    back_image: "no",
    initial_back: "no",
    initial_zoom: -1,
    initial_zoom_solo: "no",
    region_opacity: 1,
    region_hover_opacity: 0.6,
    zoom_out_incrementally: "yes",
    zoom_percentage: 0.99,
    zoom_time: 0.5,

    //Popup settings
    popup_color: "white",
    popup_opacity: 0.9,
    popup_shadow: 1,
    popup_corners: 5,
    popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
    popup_nocss: "no",

    //Advanced settings
    div: "map",
    auto_load: "no",
    url_new_tab: "no",
    images_directory: "/static/lib/simplemaps/map_images/",
    fade_time: 0.1,
    import_labels: "no",
    link_text: "View Website",
    state_image_url: "",
    state_image_position: "",
    location_image_url: ""
  },
  state_specific: {
    HI: {
      name: "Hawaii",
      hide: "yes"
    },
    AK: {
      name: "Alaska",
      hide: "yes"
    },
    FL: {
      name: "Florida",
      hide: "yes"
    },
    NH: {
      name: "New Hampshire",
      hide: "yes"
    },
    VT: {
      name: "Vermont",
      hide: "yes"
    },
    ME: {
      name: "Maine",
      hide: "yes"
    },
    RI: {
      name: "Rhode Island",
      hide: "yes"
    },
    NY: {
      name: "New York",
      hide: "yes"
    },
    PA: {
      name: "Pennsylvania",
      hide: "yes"
    },
    NJ: {
      name: "New Jersey",
      hide: "yes"
    },
    DE: {
      name: "Delaware",
      hide: "yes"
    },
    MD: {
      name: "Maryland",
      hide: "yes"
    },
    VA: {
      name: "Virginia",
      hide: "yes"
    },
    WV: {
      name: "West Virginia",
      hide: "yes"
    },
    OH: {
      name: "Ohio",
      hide: "yes"
    },
    IN: {
      name: "Indiana",
      hide: "yes"
    },
    IL: {
      name: "Illinois",
      hide: "yes"
    },
    CT: {
      name: "Connecticut",
      hide: "yes"
    },
    WI: {
      name: "Wisconsin",
      hide: "yes"
    },
    NC: {
      name: "North Carolina",
      hide: "yes"
    },
    DC: {
      name: "District of Columbia",
      hide: "yes"
    },
    MA: {
      name: "Massachusetts",
      hide: "yes"
    },
    TN: {
      name: "Tennessee",
      hide: "yes"
    },
    AR: {
      name: "Arkansas",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    MO: {
      name: "Missouri",
      hide: "yes"
    },
    GA: {
      name: "Georgia",
      hide: "yes"
    },
    SC: {
      name: "South Carolina",
      hide: "yes"
    },
    KY: {
      name: "Kentucky",
      hide: "yes"
    },
    AL: {
      name: "Alabama",
      hide: "yes"
    },
    LA: {
      name: "Louisiana"
    },
    MS: {
      name: "Mississippi",
      hide: "yes"
    },
    IA: {
      name: "Iowa",
      hide: "yes"
    },
    MN: {
      name: "Minnesota",
      hide: "yes"
    },
    OK: {
      name: "Oklahoma",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    TX: {
      name: "Texas",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    NM: {
      name: "New Mexico"
    },
    KS: {
      name: "Kansas"
    },
    NE: {
      name: "Nebraska"
    },
    SD: {
      name: "South Dakota",
      hide: "yes"
    },
    ND: {
      name: "North Dakota",
      hide: "yes"
    },
    WY: {
      name: "Wyoming"
    },
    MT: {
      name: "Montana"
    },
    CO: {
      name: "Colorado",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    UT: {
      name: "Utah"
    },
    AZ: {
      name: "Arizona",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    NV: {
      name: "Nevada",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    OR: {
      name: "Oregon"
    },
    WA: {
      name: "Washington",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    CA: {
      name: "California",
      color: "#0085CA",
      hover_color: "#0085CA"
    },
    MI: {
      name: "Michigan",
      hide: "yes"
    },
    ID: {
      name: "Idaho"
    },
    GU: {
      name: "Guam",
      hide: "yes"
    },
    VI: {
      name: "Virgin Islands",
      hide: "yes"
    },
    PR: {
      name: "Puerto Rico",
      hide: "yes"
    },
    MP: {
      name: "Northern Mariana Islands",
      hide: "yes"
    },
    AS: {
      name: "American Samoa",
      hide: "yes"
    }
  },
  locations: {

  },
  labels: {
    VT: {
      x: "883",
      y: "243",
      pill: "yes",
      width: 45
    },
    RI: {
      x: "932",
      y: "273",
      pill: "yes",
      width: 45
    },
    NJ: {
      x: "883",
      y: "273",
      pill: "yes",
      width: 45
    },
    DE: {
      x: "883",
      y: "303",
      pill: "yes",
      width: 45
    },
    MD: {
      x: "932",
      y: "303",
      pill: "yes",
      width: 45
    },
    DC: {
      x: "884",
      y: "332",
      pill: "yes",
      width: 45
    },
    MA: {
      x: "932",
      y: "213",
      pill: "yes",
      width: 45
    },
    CT: {
      x: "932",
      y: "243",
      pill: "yes",
      width: 45
    },
    HI: {
      x: 305,
      y: 565,
      pill: "yes"
    },
    AK: {
      x: "113",
      y: "495"
    },
    FL: {
      x: "773",
      y: "510"
    },
    ME: {
      x: "893",
      y: "85"
    },
    NY: {
      x: "815",
      y: "158"
    },
    PA: {
      x: "786",
      y: "210"
    },
    VA: {
      x: "790",
      y: "282"
    },
    WV: {
      x: "744",
      y: "270"
    },
    OH: {
      x: "700",
      y: "240"
    },
    IN: {
      x: "650",
      y: "250"
    },
    IL: {
      x: "600",
      y: "250"
    },
    WI: {
      x: "575",
      y: "155"
    },
    NC: {
      x: "784",
      y: "326"
    },
    TN: {
      x: "655",
      y: "340"
    },
    AR: {
      x: "548",
      y: "368"
    },
    MO: {
      x: "548",
      y: "293"
    },
    GA: {
      x: "718",
      y: "405"
    },
    SC: {
      x: "760",
      y: "371"
    },
    KY: {
      x: "680",
      y: "300"
    },
    AL: {
      x: "655",
      y: "405"
    },
    LA: {
      x: "550",
      y: "435"
    },
    MS: {
      x: "600",
      y: "405"
    },
    IA: {
      x: "525",
      y: "210"
    },
    MN: {
      x: "506",
      y: "124"
    },
    OK: {
      x: "460",
      y: "360"
    },
    TX: {
      x: "425",
      y: "435"
    },
    NM: {
      x: "305",
      y: "365"
    },
    KS: {
      x: "445",
      y: "290"
    },
    NE: {
      x: "420",
      y: "225"
    },
    SD: {
      x: "413",
      y: "160"
    },
    ND: {
      x: "416",
      y: "96"
    },
    WY: {
      x: "300",
      y: "180"
    },
    MT: {
      x: "280",
      y: "95"
    },
    CO: {
      x: "320",
      y: "275"
    },
    UT: {
      x: "223",
      y: "260"
    },
    AZ: {
      x: "205",
      y: "360"
    },
    NV: {
      x: "140",
      y: "235"
    },
    OR: {
      x: "100",
      y: "120"
    },
    WA: {
      x: "130",
      y: "55"
    },
    ID: {
      x: "200",
      y: "150"
    },
    CA: {
      x: "79",
      y: "285"
    },
    MI: {
      x: "663",
      y: "185"
    },
    PR: {
      x: "620",
      y: "545"
    },
    GU: {
      x: "550",
      y: "540"
    },
    VI: {
      x: "680",
      y: "519"
    },
    MP: {
      x: "570",
      y: "575"
    },
    AS: {
      x: "665",
      y: "580"
    }
  },
  legend: {
    entries: []
  },
  regions: {}
};
